import { createFileRoute } from "@tanstack/react-router";

import { AdminProvidersPage } from "@/components/admin/AdminProvidersPage";

export const Route = createFileRoute("/administrator/providers")({
  component: AdminProvidersPage,
});
